import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import ModalRaport from '../components/ModalRaport';
import {
  BarChart3,
  ListOrdered,
  FileBarChart,
  ShoppingBag,
  Wallet,
  ArrowDownCircle,
  ArrowUpCircle,
  AlertTriangle,
  UserCircle2,
  Ban,
  ArrowLeftRight,
  Coins,
  PieChart,
  Layers,
  Clock,
  TrendingDown,
  RefreshCcw,
  Archive,
  CreditCard,
  Users,
  Undo2,
  Truck,
  Activity,
  Globe,
} from 'lucide-react';

import RaportFitimi from '../components/raportet/RaportFitimi';
import RaportTop10 from '../components/raportet/RaportTop10';
import RaportFitimiDetajuar from '../components/raportet/RaportFitimiDetajuar';
import RaportShitje from '../components/raportet/RaportShitje';
import RaportHarxhime from '../components/raportet/RaportHarxhime';
import RaportHyrjeStok from '../components/raportet/RaportHyrjeStok';
import RaportDaljeStok from '../components/raportet/RaportDaljeStok';
import RaportStokUlet from '../components/raportet/RaportStokUlet';
import RaportShitjePerShites from '../components/raportet/RaportShitjePerShites';
import RaportShitjeOnline from '../components/raportet/RaportShitjeOnline';
import RaportProduktePaShitje from '../components/raportet/RaportProduktePaShitje';
import RaportKrahasimProdukte from '../components/raportet/RaportKrahasimProdukte';
import RaportVleraStok from '../components/raportet/RaportVleraStok';
import RaportMarzhProdukt from '../components/raportet/RaportMarzhProdukt';
import RaportMarzhKategori from '../components/raportet/RaportMarzhKategori';
import RaportShitjeKategori from '../components/raportet/RaportShitjeKategori';
import RaportShitjeOre from '../components/raportet/RaportShitjeOre';
import RaportBottom10 from '../components/raportet/RaportBottom10';
import RaportRekomandimRimbushje from '../components/raportet/RaportRekomandimRimbushje';
import RaportStokVjeter from '../components/raportet/RaportStokVjeter';
import RaportPagesa from '../components/raportet/RaportPagesa';
import RaportKliente from '../components/raportet/RaportKliente';
import RaportKthime from '../components/raportet/RaportKthime';
import RaportBlerjeFurnizues from '../components/raportet/RaportBlerjeFurnizues';
import RaportCashflow from '../components/raportet/RaportCashflow';

function Raporte() {
  const { roli } = useAuth();
  const [raportiAktiv, setRaportiAktiv] = useState(null);
  const mbyllModalin = () => setRaportiAktiv(null);

  const renderRaporti = () => {
    switch (raportiAktiv) {
      case 'fitimi': return <RaportFitimi />;
      case 'top10': return <RaportTop10 />;
      case 'bottom10': return <RaportBottom10 />;
      case 'fitimiDetaje': return <RaportFitimiDetajuar />;
      case 'shitje': return <RaportShitje />;
      case 'shitjeOnline': return <RaportShitjeOnline />;
      case 'shitjeKategori': return <RaportShitjeKategori />;
      case 'shitjeOre': return <RaportShitjeOre />;
      case 'shitjePerShites': return <RaportShitjePerShites />;
      case 'harxhime': return <RaportHarxhime />;
      case 'cashflow': return <RaportCashflow />;
      case 'pagesa': return <RaportPagesa />;
      case 'kliente': return <RaportKliente />;
      case 'kthime': return <RaportKthime />;
      case 'blerjeFurnizues': return <RaportBlerjeFurnizues />;
      case 'vleraStok': return <RaportVleraStok />;
      case 'marzhProdukt': return <RaportMarzhProdukt />;
      case 'marzhKategori': return <RaportMarzhKategori />;
      case 'hyrjeStok': return <RaportHyrjeStok />;
      case 'daljeStok': return <RaportDaljeStok />;
      case 'stokUlet': return <RaportStokUlet />;
      case 'stokVjeter': return <RaportStokVjeter />;
      case 'paShitje': return <RaportProduktePaShitje />;
      case 'rekomandimRimbushje': return <RaportRekomandimRimbushje />;
      case 'krahasimProdukte': return <RaportKrahasimProdukte />;
      default: return null;
    }
  };
  const butonatAdmin = [
    { id: 'fitimi', label: 'Raporti i Fitimit', icon: BarChart3 },
    { id: 'top10', label: 'Top 10 Produktet', icon: ListOrdered },
    { id: 'bottom10', label: 'Bottom 10 Produkte', icon: TrendingDown },
    { id: 'fitimiDetaje', label: 'Fitimi (Detaje)', icon: FileBarChart },
    { id: 'shitje', label: 'Raporti i Shitjeve', icon: ShoppingBag },
    { id: 'shitjeOnline', label: 'Shitje Online', icon: Globe },
    { id: 'shitjeKategori', label: 'Shitje per Kategori', icon: Layers },
    { id: 'shitjeOre', label: 'Shitje sipas Ores', icon: Clock },
    { id: 'shitjePerShites', label: 'Shitjet per Shites', icon: UserCircle2 },
    { id: 'harxhime', label: 'Harxhimet', icon: Wallet },
    { id: 'cashflow', label: 'Cashflow', icon: Activity },
    { id: 'pagesa', label: 'Pagesa', icon: CreditCard },
    { id: 'kliente', label: 'Kliente', icon: Users },
    { id: 'kthime', label: 'Kthime', icon: Undo2 },
    { id: 'blerjeFurnizues', label: 'Blerje nga Furnizuesit', icon: Truck },
    { id: 'vleraStok', label: 'Vlera e Stokut', icon: Coins },
    { id: 'marzhProdukt', label: 'Marzh per Produkt', icon: PieChart },
    { id: 'marzhKategori', label: 'Marzh per Kategori', icon: Layers },
    { id: 'hyrjeStok', label: 'Hyrjet ne Stok', icon: ArrowDownCircle },
    { id: 'daljeStok', label: 'Daljet nga Stoku', icon: ArrowUpCircle },
    { id: 'stokUlet', label: 'Stok i Ulet', icon: AlertTriangle },
    { id: 'stokVjeter', label: 'Stok i Vjeter', icon: Archive },
    { id: 'paShitje', label: 'Produktet pa Shitje', icon: Ban },
    { id: 'rekomandimRimbushje', label: 'Rekomandim Rimbushje', icon: RefreshCcw },
    { id: 'krahasimProdukte', label: 'Krahasim Produkte', icon: ArrowLeftRight },
  ];
  const butonatMenaxher = [
    { id: 'top10', label: 'Top 10 Produktet', icon: ListOrdered },
    { id: 'bottom10', label: 'Bottom 10 Produkte', icon: TrendingDown },
    { id: 'shitje', label: 'Raporti i Shitjeve', icon: ShoppingBag },
    { id: 'shitjeOnline', label: 'Shitje Online', icon: Globe },
    { id: 'shitjeKategori', label: 'Shitje per Kategori', icon: Layers },
    { id: 'shitjeOre', label: 'Shitje sipas Ores', icon: Clock },
    { id: 'shitjePerShites', label: 'Shitjet per Shites', icon: UserCircle2 },
    { id: 'harxhime', label: 'Harxhimet', icon: Wallet },
    { id: 'cashflow', label: 'Cashflow', icon: Activity },
    { id: 'pagesa', label: 'Pagesa', icon: CreditCard },
    { id: 'kliente', label: 'Kliente', icon: Users },
    { id: 'kthime', label: 'Kthime', icon: Undo2 },
    { id: 'blerjeFurnizues', label: 'Blerje nga Furnizuesit', icon: Truck },
    { id: 'vleraStok', label: 'Vlera e Stokut', icon: Coins },
    { id: 'marzhProdukt', label: 'Marzh per Produkt', icon: PieChart },
    { id: 'marzhKategori', label: 'Marzh per Kategori', icon: Layers },
    { id: 'hyrjeStok', label: 'Hyrjet ne Stok', icon: ArrowDownCircle },
    { id: 'daljeStok', label: 'Daljet nga Stoku', icon: ArrowUpCircle },
    { id: 'stokUlet', label: 'Stok i Ulet', icon: AlertTriangle },
    { id: 'stokVjeter', label: 'Stok i Vjeter', icon: Archive },
    { id: 'paShitje', label: 'Produktet pa Shitje', icon: Ban },
    { id: 'rekomandimRimbushje', label: 'Rekomandim Rimbushje', icon: RefreshCcw },
    { id: 'krahasimProdukte', label: 'Krahasim Produkte', icon: ArrowLeftRight },
  ];
  const butonat = roli === 'admin' ? butonatAdmin : butonatMenaxher;

  return (
    <div className="w-full animate-fade-in">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gradient-logo flex items-center gap-3 animate-slide-down">
        <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
          <BarChart3 size={32} className="text-primary-600 dark:text-primary-400" />
        </div>
        Raportet
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {butonat.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            onClick={() => setRaportiAktiv(id)}
            className="card-premium-hover p-4 flex items-center gap-4 group"
          >
            <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg group-hover:bg-primary-200 dark:group-hover:bg-primary-900/50 transition-colors">
              <Icon size={24} className="text-primary-600 dark:text-primary-400" />
            </div>
            <span className="text-left font-medium text-gray-800 dark:text-gray-200">{label}</span>
          </button>
        ))}
      </div>

      {raportiAktiv && (
        <ModalRaport onClose={mbyllModalin}>
          {renderRaporti()}
        </ModalRaport>
      )}
    </div>
  );
}

export default Raporte;
